<template>
  <div class="create-batch-check-order-job">
    <div class="content-overflow">
      <section class="left-div fixContent">
        <a-form-model ref="ruleForm">
          <div class="modalBox">
            <p>
              <i class="leftLine"></i>
              <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                {{ $t(`form.PoPrefixConfiguration`) }}
              </span>
            </p>
            <a-button type="primary" @click="isConfig = !isConfig">
              {{ $t('form.ConfigurePOPrefix') }}
            </a-button>
            <div style="margin: 20px 0">
              <p>
                <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                  {{ $t(`form.Configured`) }}
                </span>
              </p>
              <a-form :wrapper-col="{ span: 12 }">
                <a-row style="display: flex; width: 100%; flex-wrap: wrap">
                  <a-col
                    style="width: 30%; flex: none; margin-right: 20px; margin-bottom: 10px"
                    v-for="(item, index) in configured"
                    :key="index"
                  >
                    <a-form-item>
                      <span slot="label" style="width: 80px">{{ labelVal(item.buId) }}</span>
                      <a-input :disabled="!isConfig" v-model="item.purchaseOrderSnPrefix" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <div style="margin: 20px 0" v-show="isConfig">
              <p>
                <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                  {{ $t(`form.NotConfigured`) }}
                </span>
              </p>
              <a-form :wrapper-col="{ span: 12 }">
                <a-row style="display: flex; width: 100%; flex-wrap: wrap">
                  <a-col
                    style="width: 30%; flex: none; margin-right: 20px"
                    v-for="(item, index) in notConfigured"
                    :key="index"
                  >
                    <a-form-item>
                      <span slot="label" style="width: 80px">{{ labelVal(item.buId) }}</span>
                      <a-input v-model="item.purchaseOrderSnPrefix" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <div style="text-align: right" v-show="isConfig">
              <a-button type="primary" @click="onSubmit">
                {{ $t('form.determine') }}
              </a-button>
              <a-button @click="cancleFn">
                {{ $t('form.Cancel') }}
              </a-button>
            </div>
          </div>
          <div class="modalBox">
            <p>
              <i class="leftLine"></i>
              <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                {{ $t('form.PoExportBrandTemplateConfiguration') }}
              </span>
            </p>
            <div style="margin: 20px 0">
              <a-form :wrapper-col="{ span: 12 }">
                <a-row style="display: flex; width: 100%">
                  <a-col
                    style="width: 30%; flex: none; margin-right: 20px"
                    v-for="(item, index) in templateList"
                    :key="index"
                  >
                    <a-form-item>
                      <span slot="label">{{ $t(`form.Template`) + (index + 1) + ':' }}</span>
                      <span style="margin-left: 10px">{{ item.orderTemplateName }}</span>
                      <a-button
                        type="primary"
                        @click="bindingFn(item.orderTemplateCode)"
                        style="margin-left: 15px"
                      >
                        {{ $t('form.Binding') }}
                      </a-button>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </div>
          </div>
        </a-form-model>
      </section>
    </div>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
export default {
  name: 'supplyChainConfig',
  data() {
    return {
      buIdList: [],
      configured: [],
      notConfigured: [],
      isConfig: false,
      buIds: [],
      templateList: [],
    }
  },
  created() {
    let parties = JSON.parse(localStorage.getItem('partyList'))[0].parties
    this.buIds = []
    parties.forEach((item) => {
      this.buIds.push(item.partyId)
    })
    this.buIdList = [...this.buIds]
    this.getPrefixList()
    this.getPoTemplateList()
  },
  methods: {
    getPrefixList() {
      http({
        instance: this,
        url: api.purchaseOrderSnPrefixList,
        type: 'post',
        data: {
          buIdList: this.buIdList,
        },
        success: (res) => {
          let data = res.result
          let resultBuIds = []
          data.forEach((v) => {
            resultBuIds.push(v.buId)
            if (
              v.purchaseOrderSnPrefix === '' ||
              v.purchaseOrderSnPrefix === null ||
              v.purchaseOrderSnPrefix === undefined
            ) {
              this.notConfigured.push(v)
            } else {
              this.configured.push(v)
            }
          })
          let arr = []
          for (let i = 0; i < this.buIds.length; i++) {
            //用来遍历的数组使用两个数组长度比较长的，不然可能没有效果
            var stra = this.buIds[i]
            var count = 0
            for (var j = 0; j < resultBuIds.length; j++) {
              var strb = resultBuIds[j]
              if (stra == strb) {
                count++
              }
            }
            if (count === 0) {
              arr.push(stra)
            }
          }
          if (arr.length) {
            arr.forEach((v) => {
              this.notConfigured.push({
                buId: v,
                purchaseOrderSnPrefix: '',
              })
            })
          }
        },
      })
    },
    getPoTemplateList() {
      http({
        instance: this,
        url: api.supplyChainConfigPoTemplateList,
        type: 'post',
        data: {},
        success: (res) => {
          this.templateList = res.result
        },
      })
    },
    labelVal(val) {
      let parties = JSON.parse(localStorage.getItem('partyList'))[0].parties
      let result = parties.filter((item) => item.partyId === val)
      return result[0].partyName
    },
    cancleFn() {
      this.isConfig = !this.isConfig
      this.configured = []
      this.notConfigured = []
      this.getPrefixList()
    },
    onSubmit() {
      let data = this.notConfigured.concat(this.configured)
      http({
        instance: this,
        url: api.updatePurchaseOrderSnPrefix,
        type: 'post',
        data: {
          buConfigVos: data,
        },
        success: () => {
          this.configured = []
          this.notConfigured = []
          this.isConfig = !this.isConfig
          this.getPrefixList()
        },
      })
    },
    bindingFn(code) {
      http({
        instance: this,
        url: api.updatePOTemplateConfig,
        type: 'post',
        data: {
          orderTemplate: code,
        },
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.BindingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.BindingFailed`),
            })
          }
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixContent {
  height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  // display: flex;
  // justify-content: space-between;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA :deep(.ant-modal-footer) {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.inputMody {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  outline: none;
}
.inputMody::-webkit-input-placeholder {
  color: #ccc;
}
</style>
